<template>
  <div class="page-content prose">
    <div class="container">
      <div class="flex justify-center pb-8">
        <ContentInfoLinks />
      </div>

      <h1>Rijschool in Nijmegen zoeken?</h1>
      <p>
        Wie op zoek is naar een rijschool in Nijmegen waar je goed en snel wordt
        voorbereid op je praktijkexamen, zit goed op Rijscholenvergelijker.nl.
        Op deze website bieden we je namelijk de mogelijkheid om helemaal gratis
        en zonder verdere verplichting informatie aan te vragen bij
        verschillende rijscholen in je eigen omgeving. Wij zorgen er na je
        aanvraag voor dat je de volgende dag al wordt benaderd door rijscholen
        in Nijmegen en omstreken, zodat je eerst in alle rust de verschillende
        scholen kunt vergelijken voordat je een beslissing neemt. Kies niet
        meteen voor de eerste de beste rijschool in Nijmegen en bespaar tot
        honderden euro’s op je rijbewijs door een goede afweging te maken!
      </p>

      <h2>Alle rijbewijzen, elke regio</h2>
      <p>
        Natuurlijk kun je niet alleen profiteren van de mogelijkheden op
        Rijscholenvergelijker.nl wanneer je graag je autorijbewijs wilt gaan
        halen. Behalve voor het
        <nuxt-link to="/informatie-over-rijscholen/rijbewijs-b">
          rijbewijs B
        </nuxt-link>
        kun je hier ook terecht als je je
        <nuxt-link to="/informatie-over-rijscholen/rijbewijs-a">
          motorrijbewijs </nuxt-link
        >, het
        <nuxt-link to="/informatie-over-rijscholen/rijbewijs-c">
          rijbewijs C
        </nuxt-link>
        of een ander rijbewijs in de wacht wilt slepen. Daarnaast kun je
        uiteraard ook een gratis aanvraag indienen als je geen rijscholen in
        Nijmegen zoekt, maar in een andere regio op zoek bent naar een goede en
        betaalbare <nuxt-link to="/"> rijschool </nuxt-link>. Zoek je
        bijvoorbeeld een
        <nuxt-link to="/informatie-over-rijscholen/eindhoven">
          rijschool in Eindhoven
        </nuxt-link>
        of een
        <nuxt-link to="/informatie-over-rijscholen/groningen">
          rijschool in Groningen </nuxt-link
        >? Rijscholenvergelijker.nl helpt je graag verder!
      </p>

      <h2>Zoek nu naar de beste rijschool van Nijmegen!</h2>
      <p>
        Begin je zoektocht naar de beste rijschool van Nijmegen nu meteen en
        laat zonder dat je ergens aan vast zit je gegevens achter op de website.
        Rijscholenvergelijker.nl doet de rest en zorgt ervoor dat er binnen 24
        uur contact met je wordt opgenomen door verschillende rijscholen in
        Nijmegen. Profiteer van deze effectieve mogelijkheid en zorg voor
        minimale kosten!
      </p>
    </div>
  </div>
</template>

<script>
import AbstractPage from 'chimera/all/components/page/AbstractPage'
import ContentInfoLinks from '~/components/layout/ContentInfoLinks'

export default {
  components: {
    ContentInfoLinks,
  },

  extends: AbstractPage,

  layout: 'content',

  /**
   * @returns {object}
   */
  data() {
    return {
      headTitle: 'Rijscholen in Nijmegen vind je op Rijscholenvergelijker.nl!',
      headDescription:
        'Als je een rijschool in Nijmegen zoekt, biedt Rijscholenvergelijker.nl uitkomst. Vergelijk gratis offertes en kies voor de beste rijschool in Nijmegen!',
    }
  },
}
</script>
